<template>
  <div class="quienes-somos">
    <HomePageTopVue></HomePageTopVue>
    <div class="headBox">
      <div class="headCon">
        <!-- 我们是谁：您值得信赖的中国进口合作伙伴 -->
        <h1>{{ $fanyi("我们是谁：您值得信赖的中国进口合作伙伴") }}</h1>
        <!-- Rakumart 是一个一站式进口平台，替您管理整个采购、物流和进口过程。 -->
        <p>
          {{
            $fanyi(
              "Rakumart 是一个一站式进口平台，替您管理整个采购、物流和进口过程。"
            )
          }}
        </p>
        <button
          class="registerButton"
          @click="$fun.routerToPage('/Registrati')"
        >
          <!-- 立即注册 -->
          {{ $fanyi("立即注册") }}
        </button>
      </div>
      <div class="videoBox">
        <div
          class="edy-texteditor-container embed-container edy-positionable-container-maxwidth"
          contenteditable="false"
          unselectable="on"
          style="
            max-width: 100%;
            overflow: hidden;
            position: relative;
            width: auto;
          "
        >
          <div
            class="edy-padding-resizer-wrapper"
            style="padding-bottom: 56.25%"
          >
            <iframe
              id="ifrId"
              src="https://www.youtube.com/embed/K8GWyTiPqxM?si=_orTa6jrD7Wagu0l"
              frameborder="0"
              style="
                position: absolute;
                display: block;
                width: 100%;
                height: 100%;
              "
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <div class="aboutCon">
      <div class="pageBox">
        <div class="abCon">
          <div class="row towModBox">
            <img
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260624115357994692.png"
              alt=""
            />
            <div class="fontCon">
              <!-- 从中国进行B2B电子商务的最强解决方案。 -->
              <h3>{{ $fanyi("从中国进行B2B电子商务的最强解决方案。") }}</h3>
              <!-- Rakumart是一家B2B企业，其主要目标是帮助意大利企业以最经济高效的方式从中国进口产品，减少成本和流程，并为客户提供最佳的进口体验。 -->
              <p>
                {{
                  $fanyi(
                    "Rakumart是一家B2B企业，其主要目标是帮助意大利企业以最经济高效的方式从中国进口产品，减少成本和流程，并为客户提供最佳的进口体验。"
                  )
                }}
              </p>
              <!-- 总部位于中国义乌，我们拥有独立的技术研发团队，办公运营空间超过2,500平方米，集团公司所属的仓库面积达到70,000平方米，员工总数超过300人。 -->
              <p>
                {{
                  $fanyi(
                    "总部位于中国义乌，我们拥有独立的技术研发团队，办公运营空间超过2,500平方米，集团公司所属的仓库面积达到70,000平方米，员工总数超过300人。"
                  )
                }}
              </p>
              <div class="blueBorderBox">
                <div class="fontBox oficinas">
                  <p class="fontTitle">+2.500m2</p>
                  <!-- 办公室 -->
                  <p class="fontConBox">{{ $fanyi("办公室") }}</p>
                </div>
                <div class="fontBox almacenes">
                  <p class="fontTitle">+70.000m2</p>
                  <!-- 仓库 -->
                  <p class="fontConBox">{{ $fanyi("仓库") }}</p>
                </div>
                <div class="fontBox empleados">
                  <p class="fontTitle">+220</p>
                  <!-- 员工 -->
                  <p class="fontConBox">{{ $fanyi("员工") }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="row streamlineTheProcess">
            <div class="streamCon">
              <div class="streamConleft">
                <!-- 简化您从中国的购物与进口 -->
                <h3>{{ $fanyi("简化您从中国的购物与进口") }}</h3>
                <!-- 我们的平台使意大利用户能够轻松访问一体化的进口服务，包括采购、下单、质量检查、国际运输以及意大利语语的售后服务。 -->
                <p>
                  {{
                    $fanyi(
                      "我们的平台使意大利用户能够轻松访问一体化的进口服务，包括采购、下单、质量检查、国际运输以及意大利语语的售后服务。"
                    )
                  }}
                </p>
                <button @click="$fun.routerToPage('/Registrati')">
                  <!-- 立即注册 -->
                  {{ $fanyi("立即注册") }}
                </button>
              </div>
              <ul class="streamConRight">
                <li>
                  <i class="listIcon"></i>
                  <!-- 降低产品成本，提高业务盈利能力 -->
                  <span>{{ $fanyi("降低产品成本，提高业务盈利能力") }}</span>
                </li>
                <li>
                  <i class="listIcon"></i>
                  <!-- 我们负责所有文件管理、手续及海关流程 -->
                  <span>{{
                    $fanyi("我们负责所有文件管理、手续及海关流程")
                  }}</span>
                </li>
                <li>
                  <i class="listIcon"></i>
                  <!-- 在中国和意大利建立基础设施，为您的业务带来更多收益 -->
                  <span>{{
                    $fanyi("在中国和意大利建立基础设施，为您的业务带来更多收益")
                  }}</span>
                </li>
                <li>
                  <i class="listIcon"></i>
                  <!-- 提供陪伴、咨询、意大利语客户服务及售后服务 -->
                  <span>{{
                    $fanyi("提供陪伴、咨询、意大利语客户服务及售后服务")
                  }}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="row towModBox">
            <div class="fontCon">
              <!-- 寻找你想要的一切——世界工厂尽在掌握之中。 -->
              <h3>{{ $fanyi("寻找你想要的一切——世界工厂尽在掌握之中。") }}</h3>
              <!-- 目前，Rakumart 的用户可以找到在中国主要电子商务平台上提供的任何产品。 -->
              <p>
                {{
                  $fanyi(
                    "目前，Rakumart 的用户可以找到在中国主要电子商务平台上提供的任何产品。"
                  )
                }}
              </p>
              <!-- 我们广泛的合作网络使我们能够为您提供丰富的产品选择，以及每天在我们全球各地不同办事处合作的超过 100,000 家高质量的中国供应商。 -->
              <p>
                {{
                  $fanyi(
                    "我们广泛的合作网络使我们能够为您提供丰富的产品选择，以及每天在我们全球各地不同办事处合作的超过 100,000 家高质量的中国供应商。"
                  )
                }}
              </p>
              <div class="blueBorderBox">
                <div class="fontBox">
                  <!-- 数百万 -->
                  <p class="fontTitle">{{ $fanyi("数百万") }}</p>
                  <!-- 种产品可供选择 -->
                  <p class="fontConBox">{{ $fanyi("种产品可供选择") }}</p>
                </div>
                <div class="fontBox">
                  <p class="fontTitle">+100.000</p>
                  <!-- 家经过验证的供应商 -->
                  <p class="fontConBox">{{ $fanyi("家经过验证的供应商") }}</p>
                </div>
              </div>
            </div>
            <img
              src="https://span-rakumart.oss-eu-central-1.aliyuncs.com/202303/64224a14c370b.png"
              alt=""
            />
          </div>
          <div class="row useTheAdvantage">
            <div class="helpMakeMoney">
              <div class="helpMakeMoneyLeft">
                <!-- 我们帮助您的业务变得更加盈利 -->
                <h3>{{ $fanyi("我们帮助您的业务变得更加盈利") }}</h3>
                <button
                  class="registerButton"
                  @click="$fun.routerToPage('/Registrati')"
                >
                  <!-- 立即注册 -->
                  {{ $fanyi("立即注册") }}
                </button>
              </div>
              <div class="helpMakeMoneyRight">
                <!-- Rakumart 允许您在世界上最大的批发市场为您的业务备货。我们负责从工厂到您门口的整个过程，这提高了您的业务盈利能力并节省了时间。 -->
                <p>
                  {{
                    $fanyi(
                      "Rakumart 允许您在世界上最大的批发市场为您的业务备货。我们负责从工厂到您门口的整个过程，这提高了您的业务盈利能力并节省了时间。"
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="logisticalAdvantages">
              <div class="paddingBox">
                <div class="logisticalAdvantagesOpt">
                  <img
                    src="https://span-rakumart.oss-eu-central-1.aliyuncs.com/202303/642255dcd531b.png"
                    alt=""
                  />
                  <!-- 全面且简单的中国进口管理 -->
                  <p class="boxTitle">
                    {{ $fanyi("全面且简单的中国进口管理") }}
                  </p>
                  <!-- 我们负责所有的文件管理、手续和海关流程。 -->
                  <p class="boxCon">
                    {{ $fanyi("我们负责所有的文件管理、手续和海关流程。") }}
                  </p>
                </div>
              </div>
              <div class="paddingBox">
                <div class="logisticalAdvantagesOpt">
                  <img
                    src="https://span-rakumart.oss-eu-central-1.aliyuncs.com/202303/642255edbb5cd.png"
                    alt=""
                  />
                  <!-- 优化运输和进口成本 -->
                  <p class="boxTitle">{{ $fanyi("优化运输和进口成本") }}</p>
                  <!-- 我们汇总来自不同供应商的货物，并整合国际运输。 -->
                  <p class="boxCon">
                    {{
                      $fanyi("我们汇总来自不同供应商的货物，并整合国际运输。")
                    }}
                  </p>
                </div>
              </div>
              <div class="paddingBox">
                <div class="logisticalAdvantagesOpt">
                  <img
                    src="https://span-rakumart.oss-eu-central-1.aliyuncs.com/202303/64225600f3d8c.png"
                    alt=""
                  />
                  <!-- 物流基础设施为您的业务提供支持。 -->
                  <p class="boxTitle">
                    {{ $fanyi("物流基础设施为您的业务提供支持。") }}
                  </p>
                  <!-- 我们在中国拥有自有仓库供您使用。 -->
                  <p class="boxCon">
                    {{ $fanyi("我们在中国拥有自有仓库供您使用。") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="imgRow">
      <div class="imgBox">
        <div class="imgRowMap" aria-hidden="true">
          <img
            class="imgRowMapImg"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061210063035597.png"
            alt=""
          />
        </div>
        <div class="imgRowconBox">
          <!-- 我们现已覆盖三个大陆，目标是改变与中国相关的商业世界。 -->
          <div class="h1title">
            {{
              $fanyi("我们现已覆盖三个大陆，目标是改变与中国相关的商业世界。")
            }}
          </div>
          <!-- 目前，Rakumart在三个大陆运营，其关联公司位于大阪（日本）、首尔（韩国）、圣保罗（巴西）、意大利、意大利、香港和杭州（中国）。 -->
          <p>
            {{
              $fanyi(
                "目前，Rakumart在三个大陆运营，其关联公司位于大阪（日本）、首尔（韩国）、圣保罗（巴西）、意大利、意大利、香港和杭州（中国）。"
              )
            }}
          </p>
          <!-- 我们希望覆盖全球主要语言市场，利用来自中国的B2B数字贸易空间，开拓不同国家的新市场，让更多企业享受Rakumart提供的“包容性数字贸易”带来的优势。 -->
          <p>
            {{
              $fanyi(
                "我们希望覆盖全球主要语言市场，利用来自中国的B2B数字贸易空间，开拓不同国家的新市场，让更多企业享受Rakumart提供的“包容性数字贸易”带来的优势。"
              )
            }}
          </p>
        </div>
      </div>
    </div>
    <FootVue></FootVue>
  </div>
</template>
<script>
import FootVue from "../../components/foot/Foot.vue";
import HomePageTopVue from "../../components/head/HomePageTop.vue";
export default {
  data() {
    return {};
  },
  components: { HomePageTopVue, FootVue },
  computed: {},
  // 页面文案通过 $fanyi 读取 language.js，随头部中意语切换按钮展示中文或意大利语
  created() {},
  methods: {},
};
</script>
<style></style>
<style lang="scss" scoped="scoped">
@import "../../css/mixin.scss";
.quienes-somos {
  width: 100%;
  min-width: 1400px;
  background-color: #fff;
}
.registerButton {
  font-size: 16px;
  line-height: 1;
  font-weight: 500;
  background-color: #009246;
  border-radius: 50px 50px 50px 50px;
  padding: 20px 40px;
  color: white;
}
.headBox {
  margin-top: -20px;
  height: 604px;
  background-image: linear-gradient(61deg, #fff2f0 0%, #e2f0e6 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  .headCon {
    width: 516px;
    padding: 10px;

    h1 {
      color: #000000;
      font-size: 45px;
      font-weight: 700;
      line-height: 50.4px;
      margin-bottom: 20px;
    }
    p {
      margin-bottom: 34px;
      font-size: 18px;
      font-weight: 400;
      line-height: 33px;
    }
  }
  .videoBox {
    margin: 0;
    width: 684px;
    height: 384px;
    border-radius: 10px 10px 10px 10px;
    box-shadow: 0px 18px 22px -7px rgba(0, 0, 0, 0.08);
  }
}

.aboutCon {
  margin: 0 auto;
  .pageBox {
    background-color: white;
    .abCon {
      .row {
      }
      .towModBox {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        img {
          width: 600px;
        }
        .fontCon {
          display: flex;
          justify-content: center;
          flex-direction: column;
          padding: 20px;
          h3 {
            font-size: 31px;
            font-weight: 600;
            line-height: 1.4em;
            margin-bottom: 20px;
          }
          p {
            font-size: 18px;
            font-weight: 400;
            line-height: 33px;
            margin-bottom: 14.4px;
          }
          .blueBorderBox {
            display: flex;
            .fontBox {
              flex: 1;
              border-left: 5px solid #009246;
              padding-left: 20px;
              height: 80px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              .fontTitle {
                font-size: 28px;
                line-height: 1.4em;
                font-weight: 600;
                margin-bottom: 0;
              }
              .fontConBox {
                margin-bottom: 0px;
                font-size: 18px;
                font-weight: 400;
                line-height: 33px;
              }
            }
            .oficinas {
              flex: 0 0 207px;
            }
            .almacenes {
              flex: 0 0 200px;
            }
          }
        }
      }
      .streamlineTheProcess {
        width: 100%;
        // 与设计稿 streamlineTheProcess 区块背景色一致
        background-color: #013b2d;
        height: 620px;
        display: flex;
        justify-content: center;
        align-items: center;
        .streamCon {
          width: 1200px;
          display: flex;
          justify-content: center;
          .streamConleft {
            width: 626px;
            padding: 20px;
            h3 {
              color: #ffffff;
              font-size: 41px;
              font-weight: 700;
              line-height: 1.2;
              margin-bottom: 20px;
            }
            p {
              color: #ffffff;
              font-size: 18px;
              font-weight: 400;
              line-height: 33px;
              margin-bottom: 34px;
            }
            button {
              // 与设计稿品牌色/黄色按钮一致：背景 #FDC100，文字 #013B2D
              font-size: 16px;
              font-weight: 400;
              line-height: 20px;
              background-color: #fdc100;
              border: none;
              border-radius: 30px;
              padding: 20px 40px;
              color: #013b2d;
              cursor: pointer;
            }
          }
          .streamConRight {
            width: 573px;
            padding: 30px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            li {
              margin-bottom: 20px;
              &:last-child {
                margin-bottom: 0;
              }
              display: flex;
              align-items: flex-start;
              color: white;
              .listIcon {
                flex: 0 0 24px;
                height: 24px;
                // 与设计稿 streamline 列表勾选图标一致（品牌色/黄色按钮 #FDC100）
                background: url("../../assets/icon/quienes-somos-check.svg")
                  no-repeat center;
                background-size: contain;
                margin-top: 0;
                margin-right: 10px;
              }
              span {
                font-size: 18px;
                font-weight: 600;
                line-height: 30.5px;
              }
            }
          }
        }
      }
      .useTheAdvantage {
        // 与设计稿中性色/大背景一致
        background-color: #f9f9f9;
        padding: 100px 0;
        .helpMakeMoney {
          width: 1200px;
          margin: 50px auto;
          display: flex;
          justify-content: center;
          .helpMakeMoneyLeft {
            flex: 0 0 510px;
            padding: 10px;
            h3 {
              font-size: 41px;
              font-weight: 700;
              line-height: 50px;
              margin-bottom: 20px;
              color: #404040;
            }
            button {
            }
          }
          .helpMakeMoneyRight {
            padding: 10px;
            width: 607px;
            p {
              color: #404040;
              margin-bottom: 14px;
              font-size: 18px;
              font-weight: 400;
              line-height: 33px;
            }
          }
        }
        .logisticalAdvantages {
          width: 1200px;
          margin: 0 auto 20px;
          display: flex;
          .paddingBox {
            padding: 10px;
            .logisticalAdvantagesOpt {
              width: 379px;
              padding: 45px 25px 45px 25px;
              background-color: #ffffff;
              border-style: solid;
              border-width: 1px 1px 1px 1px;
              border-color: #e8e8e8;
              border-radius: 6px 6px 50px 6px;
              box-shadow: 0px 36px 19px -15px rgba(0, 0, 0, 0.05);
              img {
                margin-bottom: 11px;
                $size: 46px;
                width: $size;
                height: $size;
              }
              .boxTitle {
                margin-bottom: 8px;
                color: #404040;
                font-size: 22px;
                font-weight: 600;
                line-height: 1.5;
              }
              .boxCon {
                color: #404040;
                font-size: 18px;
                font-weight: 400;
                line-height: 33px;
              }
            }
          }
        }
      }
    }
  }
}
.imgRow {
  background: #013b2d;
  overflow: hidden;
  .imgBox {
    position: relative;
    width: 1200px;
    min-height: 620px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .imgRowMap {
      position: absolute;
      top: 50%;
      right: -140px;
      width: 900px;
      height: 580px;
      transform: translateY(-50%);
      pointer-events: none;
      .imgRowMapImg {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .imgRowconBox {
      position: relative;
      z-index: 1;
      width: 640px;
      padding: 20px;
      .h1title {
        font-size: 31px;
        font-weight: 700;
        line-height: 40px;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        font-size: 18px;
        font-weight: 400;
        line-height: 33px;
        margin-bottom: 14px;
        color: #ffffff;
      }
    }
  }
}
</style>
